import { render, staticRenderFns } from "./buildBlocks.vue?vue&type=template&id=1b820054&"
import script from "./buildBlocks.vue?vue&type=script&lang=js&"
export * from "./buildBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports